import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (backend/modules/pw9318/models/pw9318.go)
// ============================================================

export interface QueryParams {
  deptFrom?: string;  // department code range lower bound (empty = all)
  deptTo?: string;    // department code range upper bound (empty = all)
  empFrom?: string;   // employee code range lower bound (empty = all)
  empTo?: string;     // employee code range upper bound (empty = all)
  dateFrom?: string;  // attendance date lower bound YYYY-MM-DD (empty = no lower bound)
  dateTo?: string;    // attendance date upper bound YYYY-MM-DD (empty = today)
}

// AttendancePunchRow — one row from F9191 RIGHT JOIN F901 (PF9191 cursor)
// Field names use original FoxPro codes per project coding rules.
export interface AttendancePunchRow {
  // From F9191 (感應卡出勤明細)
  F9191_01: string;   // punch record key (CHAR(10))
  F9191_02: string;   // attendance date (YYYY-MM-DD)
  F9191_03: string;   // punch sequence (CHAR(8))
  F9191_11: string;   // status code (CHAR(1)): S or T
  F9191_12: string;   // department code (CHAR(4))
  F9191_13: string;   // employee code (CHAR(8))

  // From F901 (員工基本資料) via RIGHT JOIN
  F901_01: string;    // employee code (join key)
  F901_11: string;    // employee name
  F901_32: string;    // department code from employee master

  // Enriched from F106 lookup
  dept_name: string;  // department name from F106_11
}

export interface QueryResponse {
  data: AttendancePunchRow[];
  count: number;
  message?: string;
}

export interface DepartmentOption {
  code: string;
  name: string;
}

export interface EmployeeOption {
  code: string;
  name: string;
}

// ============================================================
// API methods
// ============================================================

export const pw9318Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw9318/query', params);
    return res.data;
  },

  async lookupDepartments(): Promise<DepartmentOption[]> {
    try {
      const res = await apiClient.get('/api/pw9318/lookup/departments');
      return res.data || [];
    } catch {
      return [];
    }
  },

  async lookupEmployees(): Promise<EmployeeOption[]> {
    try {
      const res = await apiClient.get('/api/pw9318/lookup/employees');
      return res.data || [];
    } catch {
      return [];
    }
  },
};
